import Home from './component/Home';
import styles from './App.css';

function App() {
  return (
    <Home />
  );
}

export default App;
